<template>
  <div>
    <section class="content-header">
      <h1>
        Биржа CPM
      </h1>
    </section>

    <section class="content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <NativeTable action="publisher/getMarket" tableType="row">
            <template slot="item-template" class="col-md-4" slot-scope="scope">
              <div class="col-md-3 mb-2" :key="scope.row.id">
                <market-item @onSelect="onSelect" :item="scope.row"></market-item>
              </div>
            </template>
          </NativeTable>
        </div>
      </div>
    </section>

    <market-order-modal ref="orderModal"></market-order-modal>
  </div>
</template>

<script>
import MarketItem from "@/components/market/MarketItem";
import MarketOrderModal from "@/components/market/MarketOrderModal";
export default {
  name: "Market",
  components: {MarketOrderModal, MarketItem},
  data: function () {
    return {
    }
  },
  methods: {
    onSelect(item) {
      this.$refs.orderModal.startOrder(item);
    }
  }
}
</script>

<style scoped>
.flex-row-m {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
}
</style>
